import React from 'react';
import { Select, Spin } from 'antd';
import { debounce } from 'lodash';

export function DebounceSelectUser({ fetchOptions, debounceTimeout = 800, ...props }) {
  const [fetching, setFetching] = React.useState(false);
  const [options, setOptions]   = React.useState([]);
  const fetchRef = React.useRef(0);

  const debounceFetcher = React.useMemo(() => {
    const loadOptions = async (value) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setOptions([]);
      setFetching(true);

      try {
        const response = await fetchOptions(value);
        const users = response?.data?.users ?? response?.users ?? [];
        if (fetchId !== fetchRef.current) return;
        const opts = users.map(user => ({
          label: user.phone,
          value: user.id,
        }));
        setOptions(opts);
      } catch (err) {
        console.error('Fetch error:', err);
      } finally {
        if (fetchId === fetchRef.current) {
          setFetching(false);
        }
      }
    };

    return debounce(loadOptions, debounceTimeout);
  }, [fetchOptions, debounceTimeout]);

  return (
      <Select
          showSearch
          maxTagCount={1}
          labelInValue
          filterOption={false}
          onSearch={debounceFetcher}
          notFoundContent={
              <span style={{ display: 'flex', justifyContent: 'center' }}>
                  {fetching ? <Spin size="small" /> : 'Ничего не найдено'}
              </span>
          }
          options={options}
          {...props}
      />
  );
}
